<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      search,
      api,
      afterGetDetail,
      initialForm,
      ...dialog,
      ...table,
      title: '菜单管理',
    }"
    @action="handleAction"
  >
  </zh-table-page>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("只为能正整数"));
      }
    };
    const state = reactive({
      search: [
        {
          component: "zh-tree-select",
          placeholder: "请选择菜单",
          value: "menuCode",
          url: "getMenuGetMenuTreeSelect",
          field: {
            menuCode: "value",
            menuName: "label",
          },
          treeKey: "menuCode",
          filterable: true,
        },
        // {
        //   component: "zh-select",
        //   label: "状态",
        //   placeholder: "状态",
        //   value: "status",
        //   url: "getSystemDictDataType",
        //   params: {
        //     id: "sys_normal_disable",
        //   },
        //   field: {
        //     dictValue: "value",
        //     dictLabel: "label",
        //   },
        // },
      ],
      api: {
        list: "getMenuGetMenuTreeSelect",
        delete: "deleteMenuDelete",
        deleteAll: "",
        add: "postMenuSave",
        edit: "postMenuUpdate",
        detail: "getMenu",
        path: "", //详情页面路由
      },
      table: {
        columns: [
          { label: "菜单名称", prop: "menuName", align: "left" },
          { label: "排序", prop: "showOrder", width: "80" },
          { label: "权限标识", prop: "perms" },
          { label: "路由地址", prop: "frongRoute" },
          { label: "组件路径", prop: "component" },
          { label: "接口地址", prop: "path" },
          {
            label: "状态",
            prop: "state",
            scopeComponent: "common-switch",
          },
          { label: "创建时间", prop: "createTime", width: "250" },
        ],
        rowKey: "menuCode",
        operations: [
          { label: "新增" },
          { label: "编辑" },
          { label: "删除", type: "danger" },
        ],
      },
      dialog: {
        dialogForm: [
          {
            component: "zh-tree-select",
            label: "上级菜单",
            placeholder: "请选择上级菜单",
            value: "parentCode",
            url: "getMenuGetMenuTreeSelect",
            field: {
              menuCode: "value",
              menuName: "label",
            },
            treeKey: "menuCode",
            showCondition: (form) => {
              return form.menuCode !== "1";
            },
          },
          {
            label: "菜单名称",
            placeholder: "请输入菜单名称",
            value: "menuName",
          },
          {
            component: "zh-select",
            label: "菜单类型",
            placeholder: "请选择菜单类型",
            value: "menuType",
            options: [
              { label: "目录", value: "M" },
              { label: "菜单", value: "C" },
              { label: "按钮", value: "F" },
            ],
          },
          {
            label: "路由地址",
            placeholder: "请输入路由地址",
            value: "frongRoute",
            showCondition: (form) => {
              return form.menuType === "C";
            },
          },
          {
            label: "组件路径",
            placeholder: "请输入组件路径",
            value: "component",
          },
          {
            label: "接口地址",
            placeholder: "请输入接口地址",
            value: "path",
            showCondition: (form) => {
              return (
                (form.menuType === "C" || form.menuType === "F") &&
                form.isFrame !== 0
              );
            },
          },
          {
            label: "权限标识",
            placeholder: "请输入权限标识",
            value: "perms",
          },
          {
            label: "菜单图标",
            placeholder: "请选择菜单图标",
            value: "icon",
            component: "zhIconDialog",
            showCondition: (form) => {
              return form.menuType != "F";
            },
          },
          {
            component: "el-input-number",
            label: "显示排序",
            placeholder: "请输入显示排序",
            value: "showOrder",
            defaultValue: 1,
            min: 1,
          },
          {
            component: "zh-select",
            label: "打开方式",
            placeholder: "请选择打开方式",
            value: "isFrame",
            defaultValue: 1,
            options: [
              { label: "页面标签", value: 1 },
              { label: "新窗口", value: 0 },
            ],
            showCondition: (form) => {
              return form.menuType === "C";
            },
          },
          {
            component: "zh-select",
            label: "菜单状态",
            placeholder: "请选择菜单状态",
            value: "state",
            url: "postDictDataList",
            params: {
              dictType: "center_use_state",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
            showCondition: (form) => {
              return form.menuType != "F";
            },
            defaultValue: 0,
          },
          {
            component: "zh-select",
            label: "菜单显示",
            placeholder: "请选择菜单显示状态",
            value: "visible",
            defaultValue: 0,
            options: [
              { label: "显示", value: 0 },
              { label: "隐藏", value: 1 },
            ],
            showCondition: (form) => {
              return form.menuType != "F";
            },
          },
        ],
        dialogRules: {
          menuName: [
            { required: true, message: "菜单名称不能为空", trigger: "blur" },
          ],
          parentCode: [
            { required: true, message: "上级菜单不能为空", trigger: "blur" },
          ],
          menuType: [
            { required: true, message: "菜单类型不能为空", trigger: "blur" },
          ],
          isFrame: [
            { required: true, message: "打开方式不能为空", trigger: "change" },
          ],
          showOrder: [
            { required: true, message: "菜单顺序不能为空", trigger: "blur" },
            { validator: blurText, trigger: "change" },
          ],
          path: [
            { required: true, message: "接口地址不能为空", trigger: "blur" },
          ],
          frongRoute: [
            { required: true, message: "路由地址不能为空", trigger: "blur" },
          ],
        },
      },
    });
    onMounted(() => {});

    //状态切换
    const handleAction = (item, type) => {
      if (type === "scope") {
        proxy
          .$confirm("是否修改菜单状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            proxy.$api.getMenu(item.menuCode).then((res) => {
              proxy.$api
                .postMenuUpdate({
                  ...res.data,
                  state: res.data.state.value == 1 ? 0 : 1,
                })
                .then((res) => {
                  tableRef.value.handleSearch();
                  proxy.$message.success("操作成功");
                });
            });
          })
          .catch(() => {
            tableRef.value.handleSearch();
          });
      }
    };

    const afterGetDetail = (data) => {
      return {
        ...data,
        state: data.state.value,
        visible: data.visible.value,
        isFrame: data.isFrame.value,
        menuType: data.menuType ? data.menuType.value : "",
      };
    };
    const initialForm = (data) => {
      if (data) {
        return {
          parentCode: data.menuCode,
        };
      }
      return {};
    };
    return {
      ...toRefs(state),
      tableRef,
      handleAction,
      afterGetDetail,
      initialForm,
    };
  },
});
</script>
